import React from "react";
import useIsMobile from "../../hooks/useIsMobile";

function classifyVehicle(sample) {
  const app = (sample?.vehicle_application || "").toLowerCase();
  const model = (sample?.vehicle_model || "").toLowerCase();
  const make = (sample?.vehicle_make || "").toLowerCase();

  if (/truck|pickup|pick.up/.test(app) ||
      /f-?1[25]0|f-?[234]50|silverado|\bram\b|tacoma|tundra|colorado|canyon|frontier|ranger|ridgeline|titan|maverick|gladiator/.test(model)) {
    return "truck";
  }
  if (/motorcycle|bike|scooter/.test(app) || /harley|kawasaki|yamaha|suzuki|ducati/.test(make)) {
    return "motorcycle";
  }
  if (/\bvan\b|minivan/.test(app) || /odyssey|sienna|caravan|quest|sprinter|express|savana|promaster|metris/.test(model)) {
    return "van";
  }
  if (/suv|crossover|sport.utility/.test(app) ||
      /outback|forester|4runner|rav4|cr-?v|pilot|explorer|tahoe|suburban|yukon|wrangler|cherokee|highlander|rogue|pathfinder|equinox|traverse|escape|edge|blazer|terrain|tucson|santa.?fe|sorento|telluride|cx-?[59]|murano|armada|compass|renegade|defender|range.?rover|passport|xterra/.test(model)) {
    return "suv";
  }
  return "sedan";
}

function IconSedan({ color }) {
  return (
    <svg viewBox="0 0 72 32" fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" style={{ display: "block", width: "100%", height: "100%" }}>
      <path d="M7 21.5h8.2m10.6 0h26.5m9.2 0H66" />
      <path d="M10.5 21.5l3-7.3c.8-1.8 2.4-2.9 4.4-3.1l9.6-.8 7.1-5.4c1.3-1 2.9-1.5 4.6-1.3l12.7 1.3c2 .2 3.7 1.3 4.7 3.1l3.5 6.1 5.2 1.6c1.7.5 2.8 2 2.8 3.8v2" />
      <path d="M28.5 10.3l8-5.4M38.5 5.2l-1.8 8.8M40.2 13.9h14.3M24.5 11.5h9.4" />
      <path d="M11.8 17.2l7.8-1.1M58.6 15.1l6.2 1.8" />
      <ellipse cx="20.4" cy="21.6" rx="5" ry="4.4" />
      <ellipse cx="56.8" cy="21.6" rx="5" ry="4.4" />
    </svg>
  );
}

function IconTruck({ color }) {
  return (
    <svg viewBox="0 0 72 32" fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" style={{ display: "block", width: "100%", height: "100%" }}>
      <path d="M6.5 21.5h8.6m10.8 0h29.6m8.2 0H68" />
      <path d="M10.2 21.5V12l30.2-2 3-5.7h12.1c1.7 0 3.3.9 4.1 2.4l4.2 7.4 2.6.9c1.3.5 2.1 1.7 2.1 3.1v3.4" />
      <path d="M11.6 12l28.8-2M43.4 4.3l-1.2 10.4M45 14.7h15.6" />
      <ellipse cx="20.4" cy="21.6" rx="5" ry="4.4" />
      <ellipse cx="59.8" cy="21.6" rx="5" ry="4.4" />
    </svg>
  );
}

function IconSUV({ color }) {
  return (
    <svg viewBox="0 0 72 32" fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" style={{ display: "block", width: "100%", height: "100%" }}>
      <path d="M7 21.5h8.3m10.6 0h25.8m9.5 0H66" />
      <path d="M10.5 21.5V13c0-2.2 1.7-4.1 3.9-4.3l11.8-1.3 5.4-4h20.1c2.1 0 4 1.1 5 2.9l4.5 8 4.7 1.3c1.4.4 2.3 1.7 2.3 3.1v2.8" />
      <path d="M11.3 14.7h49.5M50.8 5.3v16.2" />
      <ellipse cx="20.4" cy="21.6" rx="5" ry="4.4" />
      <ellipse cx="56.8" cy="21.6" rx="5" ry="4.4" />
    </svg>
  );
}

function IconVan({ color }) {
  return (
    <svg viewBox="0 0 72 32" fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" style={{ display: "block", width: "100%", height: "100%" }}>
      <path d="M7 21.5h8.4m10.7 0h25.8m9.2 0H66" />
      <path d="M10.3 21.5V8.2c0-2.4 1.9-4.4 4.3-4.4h33.1c2.3 0 4.3 1.2 5.4 3.2l7.1 12.8 5.8 1.7" />
      <path d="M11 15.2h49.2" />
      <ellipse cx="20.5" cy="21.6" rx="5" ry="4.4" />
      <ellipse cx="56.8" cy="21.6" rx="5" ry="4.4" />
    </svg>
  );
}

function IconMotorcycle({ color }) {
  return (
    <svg viewBox="0 0 72 32" fill="none" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" style={{ display: "block", width: "100%", height: "100%" }}>
      <ellipse cx="17" cy="21.5" rx="6" ry="5.3" />
      <ellipse cx="55" cy="21.5" rx="6" ry="5.3" />
      <path d="M23 21.4h10.4l8.1-10.2h10.1l4.1 10.2" />
      <path d="M32.6 21.4l-6.9-9.8h8.6l5.9 9.8" />
    </svg>
  );
}

const TYPE_ICONS = { sedan: IconSedan, suv: IconSUV, truck: IconTruck, van: IconVan, motorcycle: IconMotorcycle };

function VehicleIcon({ sample, width = 36, height = 16, color }) {
  const Icon = TYPE_ICONS[classifyVehicle(sample)] || IconSedan;
  return <div style={{ width, height, flexShrink: 0 }}><Icon color={color} /></div>;
}

function formatDate(dateStr) {
  if (!dateStr) return "N/A";
  try {
    return new Date(dateStr).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return dateStr;
  }
}

function sampleDate(sample) {
  return sample?.sample_tested_date || sample?.response_submission_timestamp || "";
}

function vehicleTitleFromSample(sample) {
  const parts = [sample?.vehicle_year, sample?.vehicle_make, sample?.vehicle_model]
    .map(value => String(value || "").trim())
    .filter(Boolean);
  return parts.length > 0 ? parts.join(" ") : "Unknown Vehicle";
}

function isReady(sample) {
  return sample?.has_test_measurements?.toUpperCase() === "YES";
}

const s = {
  section: { marginBottom: 22 },
  label: {
    fontSize: 11, fontWeight: 700, color: "var(--text-muted)",
    textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 8,
  },
  bar: {
    display: "flex", gap: 8, paddingBottom: 8, alignItems: "stretch",
    borderBottom: "2px solid var(--border)", position: "relative", overflowX: "auto",
  },
  vehicleTab: {
    flex: "0 0 auto", minWidth: 210, padding: "12px 16px",
    borderRadius: "var(--dashboard-control-radius) var(--dashboard-control-radius) 0 0",
    border: "1.5px solid var(--border)", borderBottom: "none", cursor: "pointer",
    background: "var(--dashboard-tab-bg)", position: "relative", top: 2,
    transition: "border-color 0.15s, background 0.15s, box-shadow 0.15s",
  },
  vehicleActive: {
    background: "var(--teal-bg)", borderColor: "var(--teal)",
    boxShadow: "0 -2px 8px rgba(20,184,166,0.1)",
  },
  vehicleTitle: { fontSize: 13, fontWeight: 900, color: "var(--text-primary)", marginTop: 6 },
  vehicleName: { fontSize: 11, fontWeight: 800, color: "var(--text-muted)", marginTop: 2 },
  vehicleMeta: { fontSize: 11, color: "var(--text-muted)", marginTop: 2 },
  reportBar: { display: "flex", gap: 8, flexWrap: "wrap" },
  reportBarCompact: { display: "flex", gap: 8, flexWrap: "nowrap", overflowX: "auto", paddingBottom: 2 },
  reportBtn: {
    border: "1.5px solid var(--border)", background: "var(--dashboard-selector-bg)",
    borderRadius: "var(--dashboard-control-radius)", padding: "10px 13px", cursor: "pointer",
    minWidth: 170, textAlign: "left", color: "var(--text-primary)",
  },
  reportBtnCompact: { minWidth: 148, padding: "7px 10px" },
  reportActive: { borderColor: "var(--teal)", background: "var(--teal-bg)" },
  reportPending: { opacity: 0.58, cursor: "not-allowed", background: "var(--bg-card-subtle)" },
  reportId: { fontSize: 11, fontWeight: 800, color: "var(--teal)", fontFamily: "var(--font-mono)" },
  reportDate: { fontSize: 13, fontWeight: 700, marginTop: 3 },
  reportDateCompact: { fontSize: 12 },
  reportMeta: { fontSize: 11, color: "var(--text-muted)", marginTop: 2 },
  badge: {
    display: "inline-block", fontSize: 9, fontWeight: 800, borderRadius: 4,
    padding: "1px 5px", marginLeft: 6, verticalAlign: "middle",
  },
  readyBadge: { color: "#16a34a", background: "#f0fdf4", border: "1px solid #bbf7d0" },
  pendingBadge: { color: "#f59e0b", background: "#fefce8", border: "1px solid #fde68a" },
  reviewBadge: { color: "#b45309", background: "#fffbeb", border: "1px solid #fed7aa" },
  selectWrap: { marginBottom: 18 },
  select: {
    width: "100%", padding: "11px 12px", borderRadius: "var(--dashboard-control-radius)",
    border: "1.5px solid var(--border)", background: "var(--dashboard-selector-bg)",
    color: "var(--text-primary)", fontSize: 14, fontWeight: 700,
  },
};

function VehicleTab({ group, active, onSelect }) {
  const latest = group.latestSample;
  const title = vehicleTitleFromSample(latest);
  const showName = group.label && group.label !== title;
  return (
    <button type="button" style={{ ...s.vehicleTab, ...(active ? s.vehicleActive : {}) }} onClick={() => onSelect(group.id)}>
      <VehicleIcon sample={latest} color={active ? "var(--teal)" : "var(--dashboard-tab-muted)"} />
      <div style={s.vehicleTitle}>{title}</div>
      {showName && <div style={s.vehicleName}>{group.label}</div>}
      <div style={s.vehicleMeta}>
        {group.subtitle}
        {group.pendingSamples.length > 0 && <span style={{ ...s.badge, ...s.pendingBadge }}>Pending</span>}
      </div>
      <div style={s.vehicleMeta}>Latest {formatDate(sampleDate(latest))}</div>
    </button>
  );
}

function ReportButton({ sample, active, onSelect, compact = false }) {
  const ready = isReady(sample);
  return (
    <button
      type="button"
      disabled={!ready}
      style={{ ...s.reportBtn, ...(compact ? s.reportBtnCompact : {}), ...(active ? s.reportActive : {}), ...(!ready ? s.reportPending : {}) }}
      onClick={() => ready && onSelect(sample.lab_sample_id)}
      title={!ready ? "Results are still being processed" : ""}
    >
      <div style={s.reportId}>
        {sample.lab_sample_id}
        <span style={{ ...s.badge, ...(ready ? s.readyBadge : s.pendingBadge) }}>
          {ready ? "Ready" : "Pending"}
        </span>
        {sample.account_issue_status === "review_pending" && (
          <span style={{ ...s.badge, ...s.reviewBadge }}>Review pending</span>
        )}
      </div>
      <div style={{ ...s.reportDate, ...(compact ? s.reportDateCompact : {}) }}>
        {ready ? `Tested ${formatDate(sample.sample_tested_date)}` : `Submitted ${formatDate(sample.response_submission_timestamp)}`}
      </div>
      <div style={s.reportMeta}>{sample.component_type || "Oil analysis"}</div>
    </button>
  );
}

export default function ReportSelector({
  vehicleGroups,
  selectedVehicleId,
  onVehicleSelect,
}) {
  const isMobile = useIsMobile();

  if (!vehicleGroups || vehicleGroups.length === 0) return null;

  if (isMobile) {
    return (
      <>
        <div style={s.selectWrap}>
          <div style={s.label}>Select Vehicle</div>
          <select style={s.select} value={selectedVehicleId || ""} onChange={e => onVehicleSelect(e.target.value)}>
            {vehicleGroups.map(group => (
              <option key={group.id} value={group.id}>{vehicleTitleFromSample(group.latestSample)} - {group.label} - {group.subtitle}</option>
            ))}
          </select>
        </div>
      </>
    );
  }

  return (
    <>
      <div style={s.section}>
        <div style={s.label}>Vehicles</div>
        <div style={s.bar}>
          {vehicleGroups.map(group => (
            <VehicleTab
              key={group.id}
              group={group}
              active={group.id === selectedVehicleId}
              onSelect={onVehicleSelect}
            />
          ))}
        </div>
      </div>
    </>
  );
}

export function ReportHistorySelector({ selectedGroup, selectedReportId, onReportSelect, compact = false }) {
  const isMobile = useIsMobile();
  if (!selectedGroup) return null;

  if (isMobile) {
    return (
      <div style={{ ...s.selectWrap, marginBottom: compact ? 10 : s.selectWrap.marginBottom }}>
        <div style={s.label}>Select Report</div>
        <select
          style={s.select}
          value={selectedReportId || ""}
          onChange={e => onReportSelect(e.target.value)}
        >
          {!selectedReportId && <option value="">No ready reports yet</option>}
          {selectedGroup.samples.map(sample => (
            <option key={sample.lab_sample_id} value={sample.lab_sample_id} disabled={!isReady(sample)}>
              {isReady(sample) ? "Tested" : "Pending"} {formatDate(sampleDate(sample))} - {sample.lab_sample_id}{sample.account_issue_status === "review_pending" ? " - Review pending" : ""}
            </option>
          ))}
        </select>
      </div>
    );
  }

  return (
    <div style={{ ...s.section, marginBottom: compact ? 12 : s.section.marginBottom }}>
      <div style={s.label}>Reports for {selectedGroup.label}</div>
      <div style={compact ? s.reportBarCompact : s.reportBar}>
        {selectedGroup.samples.map(sample => (
          <ReportButton
            key={sample.lab_sample_id}
            sample={sample}
            active={sample.lab_sample_id === selectedReportId}
            onSelect={onReportSelect}
            compact={compact}
          />
        ))}
      </div>
    </div>
  );
}
